export class UpdatePreferences {
  updateUserPreference(_input:any) {
    return {
      mutation: {
        updateUserPreference: {
          __args: {
            input: _input,
          },
          id: true,
          domain: true,
          upn: true,
          preferences: {
            value: true,
            key: true,
            domain: true,
            useractionrequired: true,
            userPreferenceExists:true
          },
          createdAt: true,
          createdBy: false,
          updatedAt: true,
          updatedBy: true,
        },
      },
    };
  }
}
